<template>
  <div>
    <a-spin :spinning="true" v-if="value" tip="拼命加载中">
      <div style="width: 100%" :style="{height:height}">
      </div>
    </a-spin>
    <div v-else>
      <slot></slot>
    </div>
  </div>

</template>
<script>
export default {
  name: "BigArmyLoading",
  props: {
    value: Boolean,
    height: {
      type: String,
      default: '100vh'
    }
  }
}
</script>
<style scoped lang="stylus">
:deep(.ant-spin-nested-loading){
  .ant-spin{
    max-height none;
    .ant-spin-text {
      text-align center
    }
  }
}

</style>
